import './footer.css';
import { Link  } from 'react-router-dom';
import { FaInstagram, FaFacebookF, FaTiktok } from 'react-icons/fa';
import { useLanguage } from '../contexts/LanguageContext';
import logo_nav_page from '../assets/photos/logo-missive-green-final.png'; 
import { SOCIAL_LINKS } from '../config/socialLinks';
import CustomLink from './CustomLink';

const Footer = () => {
  const { t } = useLanguage();
  const combinedClickHandler = () => {
    window.scroll(0, 0);
  };
  return (
    <div className="footer-container">
      <Link 
          to={'/'} 
          onClick={() => {
              window.scroll(0, 0);
              combinedClickHandler();
          }}
          >
          <img className="logo-nav-page" src={logo_nav_page} alt="Logo" />
      </Link>

      <div className="footer-links-main">
        <div className="footer-links">
          <CustomLink to="/" section="gallery-photos">{t('footer.photos')}</CustomLink>
          <CustomLink to="/" section="room-type">{t('footer.suites')}</CustomLink>
          <Link to={'/VirtualTour'} onClick={combinedClickHandler}>{t('footer.virtualTour')}</Link>
          <Link to={'/'} onClick={combinedClickHandler}>{t('footer.home')}</Link>
        </div>

        <div className="footer-links">
          <Link to={'/LuxurySuites'} onClick={combinedClickHandler}>{t('footer.luxurySuite')}</Link>
          <Link to={'/LuxuryDomi'} onClick={combinedClickHandler}>{t('footer.luxuryDomi')}</Link>
          <Link to={'/LuxuryVips'} onClick={combinedClickHandler}>{t('footer.luxuryVips')}</Link>
          <Link to={'/LuxuryVilla'} onClick={combinedClickHandler}>{t('footer.luxuryVilla')}<br />{t('footer.luxuryVillaSubtitle')}</Link>
        </div>
      </div>

      <div className="footer-separator"></div>

      <div className="footer-links footer-links-small">
        <Link to={'/Tos'} onClick={combinedClickHandler}>{t('footer.tos')}</Link>
        <Link to={'/Negishot'} onClick={combinedClickHandler}>{t('footer.accessibility')}</Link>
        <Link to={'/Kosher'} onClick={combinedClickHandler}>{t('footer.kosher')}</Link>
        <Link to={'/Restaurants'} onClick={combinedClickHandler}>{t('footer.restaurants')}</Link>
        <a href="/guide/">{t('footer.guestGuide')}</a>
      </div>
            
      <div className="footer-social">
        <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
        <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
        <a href={SOCIAL_LINKS.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok"><FaTiktok /></a>
      </div>

      <a className="phone" href="tel:+97249806006"><span className="phone-icon">📞</span><span>{t('footer.phone')}</span></a>
      <div className="footer-address">{t('footer.address')}</div>
    </div>
  );
};

export default Footer;
